import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
  width: calc(100% - 3rem);
  box-sizing: border-box;
  min-height: 352px;

  @media (max-width: 768px) {
    width: calc(100% - 2rem);
    margin: 1rem;
    padding: 1rem;
  }
`

export const SectionTitle = styled.h3`
  font-size: 1.125rem;
  margin: 0;
  font-weight: 600;
  color: #000;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;
